import axios from "axios";
import moment from 'moment';
import $ from "jquery";
import _ from 'lodash';

console.log = function() {};

$(document).ready(() => {
    console.log("Register ready!");
    console.log("Referrer: "+ referrer);
    let selectedDateObject = null;
    let passVisible = false;
    let lessThanFifteen = false;
    let lessThanTen = false;

    flatpickr.localize(flatpickr.l10ns.gr);
    flatpickr("#reg-date", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        maxDate: 'today',
        onChange: function(selectedDates, dateStr, instance) {
            lessThanFifteen = false;
            lessThanTen = false;
            let parsedDate = moment(dateStr, 'YYYY-MM-DD');
            selectedDateObject = parsedDate.format('DD-MM-YYYY');
            let today = moment(moment().format('YYYY-MM-DD'));
            let yearsSinceThen = today.diff(parsedDate, 'years');


            console.log(yearsSinceThen, parsedDate, today);

            if (yearsSinceThen < 10) {
                lessThanTen = true;
                alert('Έχετε συμπληρώσει ημερομηνία μικρότερη των 10 ετών. Αν έχετε κάνει λάθος μπορείτε να τη διορθώσετε, διαφορετικά δεν επιτρέπεται να εγγραφείτε στην πλατφόρμα.');
                return;
            }

            if (yearsSinceThen < 15) {
                lessThanFifteen = true;
                alert('Έχετε συμπληρώσει ημερομηνία μικρότερη των 15 ετών. Αν έχετε κάνει λάθος μπορείτε να τη διορθώσετε, διαφορετικά θα χρειαστεί να συγκατατεθεί για την εγγραφή σας στην πλατφόρμα ο γονέας/ ή κηδεμόνας σας.');
                return;
            } 
            
        },
        disableMobile: true,
    });

    $("body").on("click", "#sign-in-btn-new", event => {
        return init(selectedDateObject, referrer, lessThanTen, lessThanFifteen);
    });
    
    $("body").on("click", "#toggle-pass", event => {
        passVisible = !passVisible;

        if (passVisible) {
            $('#pse').addClass('uk-hidden');
            $('#phe').removeClass('uk-hidden');
            $('#reg-password').attr('type', 'text');
        } else {
            $('#phe').addClass('uk-hidden');
            $('#pse').removeClass('uk-hidden');
            $('#reg-password').attr('type', 'password');
        }
    });
});


const init = (inBdayValue, referrer, lessThanTen, lessThanFifteen) => {
    const fullnameEl = $('#reg-fullname')
    const emailEl = $('#reg-email');
    const passwordEl = $('#reg-password');
    const mobileEl = $('#reg-phone');
    const sexEl = $("input[name='reg-sex']:checked");
    const termsEl = $('#reg-terms');
    const cityEl = $('#sp-city');

    fullnameEl.removeClass('cu-new-empty');
    emailEl.removeClass('cu-new-empty');
    passwordEl.removeClass('cu-new-empty');
    mobileEl.removeClass('cu-new-empty');

    let fullnameValue = fullnameEl.val() && fullnameEl.val().trim();
    let emailValue = emailEl.val() && emailEl.val().trim();
    let passwordValue = passwordEl.val() && passwordEl.val().trim();
    let mobileValue = mobileEl.val() && mobileEl.val().trim();
    let sexValue = sexEl.val() && sexEl.val().trim();
    let bdayValue = inBdayValue && inBdayValue.trim();
    let termsValue = termsEl.is(":checked")
    let cityValue = cityEl.val();

    let emptyField = false;
    if (!fullnameValue) {
        emptyField = true;
        fullnameEl.addClass('cu-new-empty');
    }

    if (!emailValue) {
        emptyField = true;
        emailEl.addClass('cu-new-empty');
    }

    if (!passwordValue) {
        emptyField = true;
        passwordEl.addClass('cu-new-empty');
    }

    if (!mobileValue) {
        emptyField = true;
        mobileEl.addClass('cu-new-empty');
    }
    
    if (!cityValue) {
        alert('Παρακαλώ επιλέξτε περιοχή για να συνεχίσετε.');
        return;
    }

    if (!sexValue) {
        alert('Παρακαλώ επιλέξτε το φύλο σας για να συνεχίσετε.');
        return;
    }

    if (emptyField) {
        alert('Παρακαλώ συμπληρώστε όλα τα πεδία για να συνεχίσετε.');
        return;
    }

    if (!bdayValue) {
        alert('Παρακαλώ συμπληρώστε την ημ/νία γέννησης για να συνεχίσετε.');
        return;
    }

    if (lessThanTen) {
        alert('Έχετε συμπληρώσει ημερομηνία μικρότερη των 10 ετών. Αν έχετε κάνει λάθος μπορείτε να τη διορθώσετε, διαφορετικά δεν επιτρέπεται να εγγραφείτε στην πλατφόρμα.');
        return;
    }

    if (lessThanFifteen){
        alert('Έχετε συμπληρώσει ημερομηνία μικρότερη των 15 ετών. Αν έχετε κάνει λάθος μπορείτε να τη διορθώσετε, διαφορετικά θα χρειαστεί να συγκατατεθεί για την εγγραφή σας στην πλατφόρμα ο γονέας/ ή κηδεμόνας σας.');
        return;
    } 

    if (!termsValue) {
        alert('Παρακαλώ συμφωνήστε με τους Όρους Χρήσης και την Πολιτική Ασφαλείας για να συνεχίσετε.')
        return;
    }

    if (!emailValue.includes("@")) {
        alert('Το email που βάλατε δεν είναι σωστό.');
        return;
    }

    if (!passwordValue.length >= 6) {
        alert('Ο κωδικός σας πρέπει να είναι τουλάχιστον 6 χαρακτήρες.');
        return;
    }

    return signUp(fullnameValue, emailValue, passwordValue, mobileValue, sexValue, bdayValue, termsValue, cityValue, referrer);
}

const signUp = (fullname, email, password, mobile, sex, birthday, terms, city) => {
    $("#sp-signing-overlay").css("display", "flex");

    let username = email.split("@")[0];

    axios({
        method: "post",
        url: "/api/register",
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
        },
        data: {
            fullname,
            username,
            email,
            password,
            sex,
            city,
            birthday,
            mobile,
            terms,
            referrer,
        }
    }).then(xhr => {
        let response = xhr.data;
        let status = response.status;

        if (status == 'failure') {
            $("#sp-signing-overlay").css("display", "none");

            let alertMessage = _.values(response.message);
            let preparedMessage = _.flattenDeep(alertMessage).reduce((pre, cur) => {
                return '<li>' + pre + cur + '</li>';
            }, '');
            let element = '<ul class="uk-list uk-list-bullet">' + preparedMessage + '</ul>';

            UIkit.notification(element);
            
            this.setTimeout(() => {
                window.location.href = "/login";
            }, 5000)
        } else {
            $("#sp-signing-overlay").css("display", "none");
            UIkit.notification(response.message);
            $('#sign-up-phase').hide();
            $('#completed-phase').show();
            $("#sign-up-back-btn").css('visibility', 'hidden');
        }
    })
        .catch(error => {
            console.log("-----------");
            console.log(error);
            console.log("-----------");
        });
}